'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.array.find-last');



// WEBPACK FOOTER //
// ./~/core-js/modules/esnext.array.find-last.js